import { logInfo, log, logErr } from "@/utils/console";
import { HttpRequest, HttpRes } from "./types/http.d";
import * as ActionTypes from "./constants/jsbridge_constants";
import { OpenBrowserOption, ListenerOptions } from "./types/index";
import { creatUUid } from "@/api/utils/api_helpers";
import { isObject } from "@/utils/lodash";

const listenerManager: any = {};

class Jsbridge {
  public Jsbridge: any;

  constructor() {
    window && (window as any).WEB
      ? (this.Jsbridge = (window as any).WEB)
      : this.throwError();
  }

  public throwError() {
    throw new Error("Init Jsbrige failed");
  }

  /**
   * send msg to native
   * @param action
   * @param params
   */
  public async call<T>(action: string, params: T) {
    log("【JS_BRIGE CALL】", {
      action,
      params
    });

    return new Promise((resolve, reject) => {
      this.Jsbridge.callNative(
        (result: any) => {
          resolve(result);
          logInfo("【JS_BRIGE RESPONSE】", {
            action,
            result
          });
        },
        (error: any, response: any) => {
          const containResponse = response && isObject(error);
          reject(containResponse ? { ...error, response } : error);
          logErr("【JS_BRIGE ERROR】", {
            action,
            error,
            response
          });
        },
        action,
        params
      );
    });
  }

  /**
   * Http
   * @param params
   */
  public async http(params: HttpRequest) {
    try {
      const res: any = await this.call(ActionTypes.HTTP, params);
      return res.response;
    } catch (error) {
      console.log("http error", error);
      return Promise.reject(error);
    }
  }

  /**
   * hide loading
   */
  public async hideLoading() {
    try {
      const res = await this.call(ActionTypes.HIDE_LAUNCH_LOADING, null);
      return res;
    } catch (error) {
      return Promise.reject(error);
    }
  }
  /**
   * Launch params
   */
  public async launchParams() {
    try {
      const res = await this.call(ActionTypes.LAUNCH_PARAMS, null);
      return res;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  /*
   * iap_product 拉取iap本地化以及无效iap
   * */
  public async iapProduct(
    inapp_product_ids: string[],
    subs_product_ids: string[]
  ) {
    try {
      const res = await this.call(ActionTypes.IAP_PRODUCT, {
        inapp_product_ids,
        subs_product_ids
      });
      return res;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  /*
   * IAP支付
   * */
  public async iapPurchase(
    product_id: string,
    is_sub: boolean,
    receipt_data?: string
  ) {
    try {
      const query: any = {
        product_id,
        type: is_sub ? "subs" : "inapp"
      };
      receipt_data && (query.receipt_data = receipt_data);
      const res: any = await this.call(ActionTypes.IAP_PURCHASE, query);
      return res;
    } catch (error) {
      // 处理错误，如果同时携带response和error
      // 1、error.code === 7，抛出error，重新走iapPurchase
      // 2、error.code !== 7，直接走正常post offer逻辑
      const { code, response }: any = error;
      return !!response
        ? Promise.reject({ ...response, code })
        : Promise.reject(error);
    }
  }

  /**
   * Open Browser
   * @param url
   * @param target
   * system_browser: open_url
   * in_app_browser: app内safari
   * self_browser: 自带web_view
   * @param option
   */
  public async openBrowser(
    url: string,
    target:
      | "system_browser"
      | "in_app_browser"
      | "self_browser" = "system_browser",
    option?: OpenBrowserOption
  ) {
    try {
      const res = await this.call(ActionTypes.OPEN_BROWSER, {
        url,
        target,
        option
      });
      return res;
    } catch (error) {
      console.log("error", error);
      return Promise.reject(error);
    }
  }

  /**
   * JS 关闭浏览器
   * @param target
   */
  public async closeBrowser(
    target: "in_app_browser" | "self_browser" = "in_app_browser"
  ) {
    try {
      const res = await this.call(ActionTypes.CLOSE_BROWSER, {
        target
      });
      return res;
    } catch (error) {
      return Promise.reject(error);
    }
  }
  /**
   * 注册友盟push
   */
  public async registerUmengPush() {
    try {
      const res = await this.call(ActionTypes.REGISTER_UMENG_PUSH, null);
      return res;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  /**
   * 友盟push的设置接受的id
   * @param alias master_id
   * @param type platform
   */
  public async configUmengPush(alias: string, type: string) {
    try {
      const res = await this.call(ActionTypes.CONFIG_UMENG_PUSH, {
        alias,
        type
      });
      return res;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  // public async hideKeyboard() {
  //   try {
  //     const res = await this.call(ActionTypes.HIDE_KEYBOARD, null);
  //     return res;
  //   } catch (e) {
  //     return Promise.reject(e);
  //   }
  // }
}
export default new Jsbridge();
